// those strings should mostly be used in code that ends up in bootloader scripts
// they are meant to reduce code size by centralizing commonly used string literals

export const STR_LINK = `link`;
export const STR_MODULE = `module`;
export const STR_PRELOAD = `preload`;
export const STR_MODULEPRELOAD = `${STR_MODULE}${STR_PRELOAD}`;
export const STR_STYLESHEET = `stylesheet`;
export const STR_DOT_CSS = `.css`;
export const STR_DOT_JS = `.js`;
export const STR_LOAD = `load`;
export const STR_ONLOAD = `onload`;
export const STR_ERROR = `error`;
export const STR_ONERROR = `on${STR_ERROR}`;
export const STR_SCRIPT = `script`;

export const isCss = (href: string) => href.endsWith(STR_DOT_CSS);
